export default __webpack_public_path__ + "static/media/text.065b6b59.svg";